/* eslint-disable react/prop-types */
import React, { useState, useContext, useMemo } from "react";

import { Route, Switch } from "react-router-dom";
import Dashboard from "./components/dashboard";
import Profile from "./components/profile/Profile";
import ForgotPassword from "./components/forgotpassword";
import Lockscreen from "./components/lockscreen";

import { Appcontext } from "../approuter";
import Departments from "./components/departments/Departments";
import Designations from "./components/designations/Designations";
import Projects from "./components/projects/Projects";
import SubAdminRoute from "../routes/SubAdminRoute";

const SubAdminAppUniversal = function (props) {
  const [menu, setMenu] = useState(false);
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const { isAuth, setIsAuth } = useContext(Appcontext);

  const location = props?.location;

  useMemo(() => {
    if (
      location?.pathname == "/login" ||
      location?.pathname == "/subadmin/register" ||
      location?.pathname == "/subadmin/forgotPassword" ||
      location?.pathname == "/subadmin/lockscreen" ||
      location?.pathname == "/subadmin/conform-email" ||
      location?.pathname == "/subadmin/404" ||
      location?.pathname == "/subadmin/500"
    ) {
      setIsAuth("subadmin");
    } else {
      setIsAuth("user");
    }
  }, [location]);

  return (
    <Switch>
      <Route path="/subadmin/forgotPassword" exact component={ForgotPassword} />
      <Route path="/subadmin/lockscreen" exact component={Lockscreen} />
      <SubAdminRoute path="/subadmin" exact component={Dashboard} />
      <SubAdminRoute path="/subadmin/departments" exact component={Departments} />
      <SubAdminRoute path="/subadmin/designations" exact component={Designations} />
      <SubAdminRoute path="/subadmin/projects" exact component={Projects} />
      <SubAdminRoute path="/subadmin/profile" exact component={Profile} />
    </Switch>
  );
};

export default SubAdminAppUniversal;
